import { Box, Image, Text } from '@zillow/constellation-10';

import PremiumBadge from '../../../images/premium-badge.png';

import { getActiveProductTypePremiumFeatures } from '../../Freemium/components/FeaturesOfPremium/constants';

import { StyledTextAlignCenter } from '../../StyledComponents/StyledLayout';

const PremiumOverviewModalContent = () => {
  const renderPremiumFeatures = () => {
    return getActiveProductTypePremiumFeatures().map((item, index) => {
      const { heading, modalContent } = item;

      return (
        <Box key={index} data-testid="PremiumFeatureItem" css={{ marginBottom: '600' }}>
          <Text textStyle="body-bold" asChild>
            <p>{heading}</p>
          </Text>
          <Text asChild>
            <p>{modalContent}</p>
          </Text>
        </Box>
      );
    });
  };

  return (
    <>
      <StyledTextAlignCenter>
        <Image src={PremiumBadge} alt="premium badge" css={{ width: '130px' }} />

        <Box css={{ marginBottom: '400' }} />

        <Text textStyle="heading-sm" asChild>
          <p>Premium gives you more of what you need to successfully manage your business</p>
        </Text>
      </StyledTextAlignCenter>

      <Box css={{ marginBottom: '600' }} />

      <div data-testid="PremiumFeatureList">{renderPremiumFeatures()}</div>
    </>
  );
};

export default PremiumOverviewModalContent;
